import ExploreResourcesCarousel from "@/ui/components/explore/ExploreResourcesCarousel";
import ScreenContainer from "@/ui/layout/ScreenContainer";

const StoryMeta = {
  title: "Components/Explore/Resources Section",
  component: ExploreResourcesCarousel,
  argTypes: {},
  args: {},
  render: () => (
    <ScreenContainer isScrollView>
      <ExploreResourcesCarousel
        data={[
          {
            imageUrl: { uri: "https://picsum.photos/800/400" },
            link: "https://example.com",
            title: "How to Cope with Anxiety",
            type: "Article",
          },
          {
            imageUrl: { uri: "https://picsum.photos/800/400" },
            link: "https://example.com",
            title: "How to Cope with Stress",
            type: "Article",
          },
        ]}
        title="Coping Skills"
      />
    </ScreenContainer>
  ),
};

export default StoryMeta;

export const Primary = {};
